import { Aperture } from "lucide-react";

const ITEMS = [
  "Interior Photography",
  "Exterior Photography",
  "Aerial Drone",
  "Twilight Shoots",
  "MLS-Ready Delivery",
  "Astoria · Oregon Coast",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display px-10 text-sm font-bold uppercase tracking-[0.3em] text-zinc-600">
          {item}
        </span>
        <Aperture size={13} className="shrink-0 text-[#D4AF37]/70" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-white/[0.07] bg-[#0C0C0F] py-6"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
